export const APP_PREFIX = process.env.NODE_ENV === 'production' ? '/promo' : ''

export const getReCaptchaSiteKey = () => {
  // на деве бесплатный ключ
  if (window?.location.host.match(/\.dev\.almara\.org|localhost/)) {
    return '6Lcf8scqAAAAAPWtjmt2Zr3DygZdvsrIchpENa8P';
  }

  // платный ключ
  return '6LcVxrYqAAAAAFC0UvfRWY1-pnHRcF72-JFWmm2l';
};
